export interface AppConfig {
  googleClientId: string;
  environment: string;
  appBaseUrl: string;
}

const DEFAULTS: AppConfig = {
  googleClientId: '',
  environment: 'prod',
  appBaseUrl: 'https://notify-u.com',
};

let _promise: Promise<AppConfig> | null = null;

export function getAppConfig(): Promise<AppConfig> {
  if (!_promise) {
    _promise = fetch('/api/config')
      .then(r => r.json())
      .catch(() => DEFAULTS);
  }
  return _promise;
}